import { customFetch } from "../../utils/Auth";
import { environment } from "../../config/environment";

const API_BASE = environment.apiUrl || "";
const BASE_URL = `${API_BASE}/notifications`;

const toClient = (row) => ({
  id: row.id,
  title: row.title,
  notificationMessage: row.notification_message,
  status: row.status,
  urgency: row.urgency,
  targetAudience: row.target_audience,
  platforms: row.platforms || [],
  duration: row.duration,
  recipientCount: row.recipient_count || 0,
  createdAt: row.created_at,
  expiryTime: row.expiry_time,
  scheduledSendTime: row.scheduled_send_time,
  isActive: row.is_active,
  createdBy: row.created_by,
  updatedAt: row.updated_at,
});

const toServer = (data) => ({
  title: data.title,
  notification_message: data.notificationMessage,
  urgency: data.urgency,
  target_audience: data.targetAudience,
  platforms: data.platforms,
  duration: data.duration,
  status: data.status,
  scheduled_send_time:
    typeof data.scheduledSendTime === "number"
      ? new Date(data.scheduledSendTime * 1000).toISOString()
      : data.scheduledSendTime,
  expiry_time:
    typeof data.expiryTime === "number"
      ? new Date(data.expiryTime * 1000).toISOString()
      : data.expiryTime,
  recipient_count: data.recipientCount,
  is_active: data.isActive,
  created_by: data.createdBy,
});

const handleResponse = async (response) => {
  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    const message = errorBody.error || "Request failed";
    throw new Error(message);
  }
  return response.json();
};

export const listNotifications = async () => {
  const response = await customFetch(BASE_URL, { method: "GET" });
  const data = await handleResponse(response);
  return Array.isArray(data) ? data.map(toClient) : [];
};

export const createNotification = async (payload) => {
  const createdBy = payload.createdBy || localStorage.getItem("username");
  const response = await customFetch(BASE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(toServer({ ...payload, createdBy })),
  });
  const data = await handleResponse(response);
  return toClient(data);
};

export const updateNotification = async (id, payload) => {
  const response = await customFetch(`${BASE_URL}/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(toServer(payload)),
  });
  const data = await handleResponse(response);
  return toClient(data);
};

export const deleteNotification = async (id) => {
  const response = await customFetch(`${BASE_URL}/${id}`, {
    method: "DELETE",
  });
  await handleResponse(response);
  return true;
};
